import '../stylesheets/booking_modal.css';

import React from 'react';
import { Modal } from 'react-bootstrap';

import PoiRequest from './PoiRequest';

const closeButtonStyle = {
  position: 'absolute',
  top: 20,
  right: 20,
  width: 32,
  height: 32,
  border: 'none',
  borderRadius: '50%',
  background: 'rgba(0, 0, 0, 0.6)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 1,
};

const PoiRequestModal = ({ show, onHide, centered = true, ...requestProps }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered={centered}
      dialogClassName='booking-modal-dialog'>
      <Modal.Body style={{ padding: 0, position: 'relative' }}>
        <button
          type='button'
          onClick={onHide}
          aria-label='Close'
          className='modal-close-button'
          style={closeButtonStyle}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'>
            <path
              d='M3 3L13 13M13 3L3 13'
              stroke='white'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </svg>
        </button>
        <PoiRequest {...requestProps} onClose={onHide} />
      </Modal.Body>
    </Modal>
  );
};

export default PoiRequestModal;
